import React, { FC, ReactNode, memo, useCallback } from 'react';

import { useAuth } from '@contexts/common/AuthorizationContext';

import { useSwitchChain } from '@hooks/common/useSwitchChain';

import Button, { ButtonProps } from '@components/common/Button';

import { Size } from '@constants/common/ui.constants';

interface Props extends ButtonProps {
  className?: string;
  chainId: number;
  children?: ReactNode;
  fullWidth?: boolean;
  title?: string;
}

const SwitchChainButton: FC<Props> = ({
  size = Size.Large,
  className,
  chainId,
  iconRight,
  children,
  fullWidth = false,
  title,
  variant,
}) => {
  const { switchChain } = useSwitchChain();
  const { chainId: currentChainId } = useAuth();

  const handleChange = useCallback(async () => {
    await switchChain(chainId);
  }, [chainId, switchChain]);

  return (
    <>
      {currentChainId === chainId ? (
        <>{children}</>
      ) : (
        <Button
          size={size}
          variant={variant}
          onClick={handleChange}
          fullWidth={fullWidth}
          className={className}
          iconRight={iconRight}
        >
          {title || 'Switch'}
        </Button>
      )}
    </>
  );
};

export default memo(SwitchChainButton);
